import { INCLUDE_INHALERS } from '@/constants/app-variables'

export const CHART_DATE_FORMAT = {
  TIME_ABBR: 'ddd, MMM D h:mmA z',
  TIME: 'ddd, MMM D h:mmA z',
  TIME_ONLY_ABBR: 'h:mmA z',
  HOUR_ABBR: 'hA z',
  DATE_ABBR: 'MMM D z',
  DAY_ABBR: 'ddd, MMM DD z',
  DETAIL_ABBR: 'MMMM DD, YYYY  • h:mm A z',
  DETAIL: 'MMMM DD, YYYY  • h:mm A',
  DATE: 'MMM D',
}

export const PATIENT_STATS_DETAILED_REPORT_TYPES = {
  ACTIVITY: { key: 'activity', label: 'Activity' },
  SLEEP: { key: 'sleep', label: 'Sleep' },
  MAINTENANCE_INHALER: { key: 'maintenanceInhaler', label: 'Maintenance Inhaler' },
  RESCUE_INHALER: { key: 'rescueInhaler', label: 'Rescue Inhaler' },
}
